import { z } from "zod";

export const partnerInviteSchema = z.object({});
export type PartnerInviteValues = z.infer<typeof partnerInviteSchema>;
